export default "__VITE_ASSET__TYj5YR4H__"